// User-facing strings for the silent auto-activation handshake. Centralised
// so the hook + stepper + toast emit identical phrasing and a future i18n
// pass can swap implementations without touching the orchestrator.
//
// Per-card ceiling numbers are never disclosed. Internal bot error codes
// are never surfaced to the user; the hook maps them to copy constants.

export const AUTO_ACTIVATION_COPY = {
  loading_short: 'Activating your card…',
  loading_long: 'Still activating; this is taking a moment.',
  success_toast: 'Your card is ready to use.',
  err_rate_limited: 'We just tried. Please wait {{n}}s before trying again.',
  err_retrieval_4xx: "We couldn't activate this card automatically. Tap below to contact support.",
  err_retrieval_5xx: "Couldn't reach the card service. Check your connection.",
  err_invalid_code: "Something went wrong on our side. We've logged it; please contact support.",
  err_uncertain: "We're not sure if activation finished. Refreshing your card…",
  cta_activate: 'Activate card',
  cta_try_again: 'Try again',
  cta_contact_support: 'Contact support',
  cta_track_delivery: 'Track delivery',
  step_delivered: 'Delivered',
  step_active: 'Active',
  aria_phase_working: 'Activating your card.',
  aria_phase_succeeded: 'Your card is ready to use.',
  aria_phase_failed: "Couldn't activate your card automatically.",
  aria_phase_waiting: 'Try-again will be available shortly.',
} as const;

// Hand-rolled placeholder substitution. Hand-rolled keeps the bundle small
// and the call site explicit until the project adopts an i18n runtime.
export const formatRateLimited = (seconds: number): string =>
  AUTO_ACTIVATION_COPY.err_rate_limited.replace('{{n}}', String(Math.max(0, Math.floor(seconds))));
